import { createAction, props } from '@ngrx/store';

import { DashCounters } from 'src/app/_apps/auth/domain/models/back/dash-counters';
import { Entity } from 'src/app/_apps/auth/domain/models/back/entity';

export const BackAuthCountersRequested = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Requested'
);

export const BackAuthCountersLoaded = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Loaded',
    props<{ entitiesCounters: DashCounters, usersCounters: DashCounters }>()
);

export const BackAuthEntitiesCleared = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities Cleared',
    props<{ external: boolean }>()
);

export const BackAuthUsersCleared = createAction(
    '[BACK-AUTH-USERS] Back Auth External Users Cleared',
    props<{ external: boolean }>()
);

export const BackAuthUserEntityRequested = createAction(
    '[BACK-AUTH-USER] Back Auth User Entity Requested',
    props<{ entityId: string }>()
);

export const BackAuthUserEntityLoaded = createAction(
    '[BACK-AUTH-USER] Back Auth User Entity Loaded',
    props<{ entity: Entity }>()
);
